"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9918],{

/***/ 99918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ timer_vertical_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs.js + 5 modules
var vertical_timer_tabs = __webpack_require__(34864);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timer-vertical-tabs/timer-vertical-tabs-component.scss.js

var StyledTimerVerticalTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1j7gr570"
})("&.center-align{.vertical-timer-tabs{.desktop-wrapper{.timer-vertical-tabs-desktop-component{.vertical-timer-tabs-container{justify-content:center;.desktop-tabs-text-container{.vertical-timer-tab-desktop-container{margin-bottom:var(--tab-space,32px);}}}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/default-props.js
var default_props = __webpack_require__(83246);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timer-vertical-tabs/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}

/* harmony default export */ var timer_vertical_tabs_default_props = (_object_spread({}, default_props/* default */.Z));

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timer-vertical-tabs/timer-vertical-tabs-component.js
function timer_vertical_tabs_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timer_vertical_tabs_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timer_vertical_tabs_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var TimerVerticalTabsComponent = function(_param) {
    var isAlignedToCenter = _param.isAlignedToCenter, tabsSpace = _param.tabsSpace, rest = _object_without_properties(_param, [
        "isAlignedToCenter",
        "tabsSpace"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerVerticalTabsComponent, {
        className: classnames_default()("timer-vertical-tabs-component", {
            "center-align": isAlignedToCenter
        }),
        style: {
            "--tab-space": tabsSpace
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vertical_timer_tabs/* default */.Z, timer_vertical_tabs_component_object_spread({}, rest))
    });
};
TimerVerticalTabsComponent.defaultProps = timer_vertical_tabs_default_props;
/* harmony default export */ var timer_vertical_tabs_component = (TimerVerticalTabsComponent);


/***/ })

}]);